import { render, staticRenderFns } from "./SynonymsSettingsCard.vue?vue&type=template&id=4ccbf128&scoped=true&"
import script from "./SynonymsSettingsCard.vue?vue&type=script&lang=js&"
export * from "./SynonymsSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./SynonymsSettingsCard.vue?vue&type=style&index=0&id=4ccbf128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbf128",
  null
  
)

export default component.exports